'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true,
});
exports.default = void 0;

var _react = require('react');

var _core = require('@material-ui/core');

var _jsxRuntime = require('react/jsx-runtime');

var ActivateButton = (0, _core.withStyles)(function (theme) {
  return {
    root: {
      backgroundColor: theme.palette.success.main,
      border: theme.palette.success.main,
      color: theme.palette.common.white,
      '&:hover': {
        backgroundColor: theme.palette.success.dark,
        border: theme.palette.success.dark,
      },
    },
  };
})(_core.Button);
var DeactivateButton = (0, _core.withStyles)(function (theme) {
  var augmentRed = theme.palette.augmentColor(theme.palette.red);
  return {
    root: {
      backgroundColor: augmentRed.main,
      border: augmentRed.main,
      color: theme.palette.common.white,
      fontWeight: 'bold',
      '&:hover': {
        backgroundColor: augmentRed.dark,
        border: augmentRed.dark,
      },
    },
  };
})(_core.Button);

var UserStatusButton = function UserStatusButton(_ref) {
  var status = _ref.status,
    onToggleStatus = _ref.onToggleStatus,
    disabled = _ref.disabled,
    _ref$activateLabel = _ref.activateLabel,
    activateLabel =
      _ref$activateLabel === void 0 ? 'Activate' : _ref$activateLabel,
    _ref$deactivateLabel = _ref.deactivateLabel,
    deactivateLabel =
      _ref$deactivateLabel === void 0 ? 'Deactivate' : _ref$deactivateLabel,
    onCheckValidToDeactivate = _ref.onCheckValidToDeactivate;
  var onActivate = (0, _react.useCallback)(
    function () {
      onToggleStatus(true);
    },
    [onToggleStatus]
  );
  var onDeactivate = (0, _react.useCallback)(
    function () {
      if (onCheckValidToDeactivate) {
        onCheckValidToDeactivate();
        return;
      }

      onToggleStatus(false);
    },
    [onCheckValidToDeactivate, onToggleStatus]
  );
  return !status
    ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(ActivateButton, {
        variant: 'outlined',
        onClick: onActivate,
        disabled: disabled,
        children: activateLabel,
      })
    : /*#__PURE__*/ (0, _jsxRuntime.jsx)(DeactivateButton, {
        variant: 'outlined',
        onClick: onDeactivate,
        disabled: disabled,
        children: deactivateLabel,
      });
};

var _default = /*#__PURE__*/ (0, _react.memo)(UserStatusButton);

exports.default = _default;

//# sourceMappingURL=index.js.map
